/**
 * Reads a property whose name is only known at runtime. Column and field names
 * come off configuration as plain strings, and the interfaces they read from
 * have no index signature, so `value[name]` does not compile. Reflect reads a
 * key off a type without one. The bag itself is often optional, so an absent
 * one reads as an absent field rather than making every caller guard.
 */
export const readField = (
  value: object | null | undefined,
  name: string,
): unknown => (value ? Reflect.get(value, name) : undefined);

/** The same read, narrowed to what a cell can render. */
export const readFieldText = (
  value: object | null | undefined,
  name: string,
): string | number | undefined => {
  const field = readField(value, name);
  return typeof field === 'string' || typeof field === 'number'
    ? field
    : undefined;
};

export const readFieldString = (
  value: object | null | undefined,
  name: string,
): string | undefined => {
  const field = readField(value, name);
  return typeof field === 'string' ? field : undefined;
};

export const readFieldNumber = (
  value: object | null | undefined,
  name: string,
): number | undefined => {
  const field = readField(value, name);
  return typeof field === 'number' ? field : undefined;
};
